// extracted by mini-css-extract-plugin
export default {"container":"ModalImage_container__Teefh","image":"ModalImage_image__1TM+b"};